import { decode } from 'blurhash'


export default function setupCanvasBlurhash(canvas, image) {
  const pixels = decode(image.blurhash, canvas.width, canvas.height);
  if (pixels) {
    const ctx = canvas.getContext('2d')
    const imageData = new ImageData(pixels, canvas.width, canvas.height)
    ctx.putImageData(imageData, 0, 0)
  }
}